import { render, staticRenderFns } from "./LoanDetails.vue?vue&type=template&id=76abc50f&scoped=true&"
import script from "./LoanDetails.vue?vue&type=script&lang=ts&"
export * from "./LoanDetails.vue?vue&type=script&lang=ts&"
import style0 from "./LoanDetails.vue?vue&type=style&index=0&id=76abc50f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76abc50f",
  null
  
)

export default component.exports